module.exports = __webpack_public_path__ + "static/media/Ahmed Darwish Photo.9f36ae64.jpg";